import React from "react";
import AuthService from "../services/AuthService";
import { Roles, AccessLevel } from "../helpers/Common";
import { Route, Redirect } from "react-router";

/**
 * Component que genera las rutas privadas y limita su acceso.
 * @Component
 */

const PrivateRoute = ({ component: Component, acceso: Acceso, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      let AccessRequired = Acceso !== undefined;

      let authorized = false;
      let readOnly = true;

      let keyuser = false;
      let isDSC = false;
      let isPartner = false;
      let isEndcustomer = false;

      let userInfo = AuthService.getUserInfo();
      let userRole = AuthService.getRole();

      let isAuthenticated = AuthService.isAuthenticated();
      let isPremium = AuthService.userPremium();

      let redirect = null;

      switch (userRole) {
        case Roles.Admin:
          keyuser = true;
          authorized = true;
          readOnly = false;
          break;
        case Roles.DSC:
          isDSC = true;
          break;
        case Roles.Partner:
          isPartner = true;
          break;
        case Roles.EndCustomer:
          isEndcustomer = true;
          break;
        default:
          break;
      }

      if (isAuthenticated && !AccessRequired) {
        authorized = true;
      } else if (isAuthenticated && AccessRequired && !keyuser) {
        switch (Acceso.nivel.toString()) {
          // PartnersClientsList
          case AccessLevel.PartnersClientes:
            switch (userRole) {
              case Roles.DSC:
              case Roles.Partner:
                authorized = true;
                readOnly = false;
                break;
              case Roles.EndCustomer:
                authorized = true;
                readOnly = true;
                break;
              default:
                break;
            }
            break;
          // PlantasDetails
          case AccessLevel.Planta:
            if (Acceso.varId === "nueva-planta") {
              switch (userRole) {
                case Roles.DSC:
                  if (!userInfo.isReadOnly && !userInfo.isGlobal) {
                    authorized = true;
                    readOnly = false;
                  } else {
                    authorized = false;
                    readOnly = true;
                  }
                  break;
                case Roles.Partner:
                  authorized = true;
                  readOnly = false;
                  break;
                case Roles.EndCustomer:
                  authorized = false;
                  readOnly = true;
                  break;
                default:
                  break;
              }
            } else {
              readOnly = false;
              authorized = true;
            }
            break;
          // ZonasDetails & EquiposDetails
          case AccessLevel.Zone:
          case AccessLevel.Equipo:
            authorized = true;
            readOnly = false;
            break;
          // UsersList, UserDetails & UserAdd
          case AccessLevel.Usuarios:
            if (Acceso.varId === "nuevo-usuario") {
              switch (userRole) {
                case Roles.DSC:
                  if (!userInfo.isReadOnly && !userInfo.isGlobal) {
                    authorized = true;
                    readOnly = false;
                  } else {
                    authorized = false;
                    readOnly = true;
                  }
                  break;
                case Roles.Partner:
                  authorized = true;
                  readOnly = false;
                  break;
                case Roles.EndCustomer:
                  authorized = false;
                  readOnly = true;
                  break;
                default:
                  break;
              }
            } else {
              switch (userRole) {
                case Roles.DSC:
                  authorized = true;
                  readOnly = userInfo.isReadOnly || userInfo.isGlobal;
                  break;
                case Roles.Partner:
                  authorized = true;
                  readOnly = false;
                  break;
                case Roles.EndCustomer:
                  authorized = false;
                  readOnly = true;
                  break;
                default:
                  break;
              }
            }
            break;
          case AccessLevel.Broadcast:
            switch (userRole) {
              case Roles.DSC:
              case Roles.Partner:
                authorized = true;
                break;
              case Roles.EndCustomer:
                authorized = false;
                break;
              default:
                break;
            }
            break;
          case AccessLevel.Dashboard:
            if ((isEndcustomer || isPartner) && !isPremium) {
              authorized = false;
              redirect = "/plantas";
            } else {
              authorized = true;
            }
            break;
          case AccessLevel.None:
            authorized = true;
            break;
          default:
            break;
        }
      }

      if (isDSC && (userInfo.isReadOnly || userInfo.isGlobal)) {
        readOnly = true;
      }

      if (authorized) {
        return (
          <Component
            {...props}
            accessPR={{
              readOnlyPR: readOnly,
              userRole,
              userIsPremium: isPremium,
              userIsReadOnly: userInfo.isReadOnly,
              userIsGlobal: userInfo.isGlobal,
              userIsRegionManager: userInfo.isRegionManager,
              keyuser,
              isDSC,
              isPartner,
              isEndcustomer,
            }}
          />
        );
      } else {
        return (
          <Redirect
            to={{
              pathname:
                isAuthenticated && AccessRequired
                  ? redirect || "/unauthorized"
                  : "/login",
              search: props.location.search,
              state: { referrer: props.location.pathname },
            }}
          />
        );
      }
    }}
  />
);

export default PrivateRoute;
